module.exports = "<h3>\r\n    Liste der Benutzer\r\n</h3>\r\n\r\n<app-table-template *ngIf=\"users && columns\" [data]=\"users\" [columns]=\"columns\"></app-table-template><br>"


//////////////////
// WEBPACK FOOTER
// ./src/app/publisherUser/publisher.user.component.html
// module id = 272
// module chunks = 1